<div class="grid grid-cols-12 gap-2 p-2">
  <!-- isAuthenticated: {{ isAuthenticated }} -->

  @if (isAuthenticated) { @if (menuItems.length > 0) {
  <div class="col-span-12">
    <p-menubar [model]="menuItems" />
  </div>
  } }

  <div class="col-span-12">
    <router-outlet></router-outlet>
  </div>
</div>
